import { createSlice } from '@reduxjs/toolkit';

import type { ProcessosState } from '@/types/processos/processoStoreTypes';

import {
  atualizarEtapa,
  atualizarProcesso,
  buscarProcessoPorId,
  criarProcesso,
  listarProcessos,
  removerProcesso,
} from './actions';

const initialState: ProcessosState = {
  itens: [],
  paginacao: { page: 1, limit: 20, total: 0, totalPages: 0 },
  carregando: false,
  erro: null,
  erroListagem: null,
  filtro: {},
  atual: undefined,
};

const processosSlice = createSlice({
  name: 'processos',
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarProcessos.pending, (state) => {
        state.carregando = true;
        state.erroListagem = null;
      })
      .addCase(listarProcessos.fulfilled, (state, action) => {
        state.carregando = false;
        state.itens = action.payload.data;
        state.paginacao = action.payload.pagination;
      })
      .addCase(listarProcessos.rejected, (state, action) => {
        state.carregando = false;
        state.erroListagem =
          (action.payload as string) || action.error.message || 'Erro ao listar processos';
      })
      .addCase(buscarProcessoPorId.pending, (state) => {
        state.carregando = true;
        state.erro = null;
      })
      .addCase(buscarProcessoPorId.fulfilled, (state, action) => {
        state.carregando = false;
        state.atual = action.payload;
      })
      .addCase(buscarProcessoPorId.rejected, (state, action) => {
        state.carregando = false;
        state.erro =
          (action.payload as string) || action.error.message || 'Erro ao buscar processo';
      })
      .addCase(criarProcesso.pending, (state) => {
        state.carregando = true;
        state.erro = null;
      })
      .addCase(criarProcesso.fulfilled, (state, action) => {
        state.carregando = false;
        state.atual = action.payload;
        state.itens = [action.payload, ...state.itens];
      })
      .addCase(criarProcesso.rejected, (state, action) => {
        state.carregando = false;
        state.erro = (action.payload as string) || action.error.message || 'Erro ao criar processo';
      })
      .addCase(atualizarProcesso.pending, (state) => {
        state.carregando = true;
        state.erro = null;
      })
      .addCase(atualizarProcesso.fulfilled, (state, action) => {
        state.carregando = false;
        state.atual = action.payload;
        state.itens = state.itens.map((p) =>
          p.id === action.payload.id ? { ...p, ...action.payload } : p,
        );
      })
      .addCase(atualizarProcesso.rejected, (state, action) => {
        state.carregando = false;
        state.erro =
          (action.payload as string) || action.error.message || 'Erro ao atualizar processo';
      })
      .addCase(atualizarEtapa.fulfilled, (state, action) => {
        state.atual = action.payload;
        state.itens = state.itens.map((p) =>
          p.id === action.payload.id ? { ...p, ...action.payload } : p,
        );
      })
      .addCase(removerProcesso.fulfilled, (state, action) => {
        state.itens = state.itens.filter((p) => p.id !== action.payload);
        if (state.atual?.id === action.payload) state.atual = undefined;
      });
  },
});

export const processosReducer = processosSlice.reducer;
